import { m as merge, z as getComponentFromVNode, A as copyAppContext, _ as _defineProperty } from './helpers-O9h6_ICO.js';
import { _ as _createClass, a as _classCallCheck } from './classCallCheck-E4khD9xn.js';
import { openBlock, createBlock, Transition, withCtx, withDirectives, createElementVNode, normalizeClass, renderSlot, createElementBlock, Fragment, createCommentVNode, vShow, createApp, h } from 'vue';
import { c as config } from './config-nHWiBviw.js';
import { N as NoticeMixin } from './NoticeMixin-6c_QVv-2.js';
import { r as registerComponentProgrammatic } from './plugins-C7548x21.js';
import './typeof-Z4rCTFCZ.js';

var script = {
    name: 'BToast',
    mixins: [NoticeMixin],
    data() {
        return {
            newDuration: this.duration || config.defaultToastDuration
        }
    }
};

const _hoisted_1 = ["aria-hidden"];
const _hoisted_2 = ["innerHTML"];

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock(Transition, {
    "enter-active-class": _ctx.transition.enter,
    "leave-active-class": _ctx.transition.leave,
    persisted: ""
  }, {
    default: withCtx(() => [
      withDirectives(createElementVNode("div", {
        onMouseenter: _cache[0] || (_cache[0] = (...args) => (_ctx.pause && _ctx.pause(...args))),
        onMouseleave: _cache[1] || (_cache[1] = (...args) => (_ctx.removePause && _ctx.removePause(...args))),
        class: normalizeClass(["toast", [_ctx.type, _ctx.position]]),
        "aria-hidden": !_ctx.isActive,
        role: "alert"
      }, [
        (_ctx.$slots.default)
          ? renderSlot(_ctx.$slots, "default", { key: 0 })
          : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createCommentVNode(" eslint-disable-next-line vue/no-v-html "),
              createElementVNode("div", { innerHTML: _ctx.message }, null, 8 /* PROPS */, _hoisted_2)
            ], 64 /* STABLE_FRAGMENT */))
      ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_1), [
        [vShow, _ctx.isActive]
      ])
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["enter-active-class", "leave-active-class"]))
}

script.render = render;
script.__file = "src/components/toast/Toast.vue";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ToastProgrammatic = /*#__PURE__*/function () {
  function ToastProgrammatic(app) {
    _classCallCheck(this, ToastProgrammatic);
    this.app = app; // may be undefined in the testing environment
  }
  _createClass(ToastProgrammatic, [{
    key: "open",
    value: function open(params) {
      if (typeof params === 'string') {
        params = {
          message: params
        };
      }
      var defaultParam = {
        position: config.defaultToastPosition || 'is-top'
      };
      if (params.parent) {
        delete params.parent;
      }
      var slot;
      if (Array.isArray(params.message)) {
        slot = params.message;
        delete params.message;
      }
      var propsData = merge(defaultParam, params);
      var container = document.createElement('div');
      // Vue 3 requires a new app to mount another component
      var vueInstance = createApp({
        data: function data() {
          return {
            toastVNode: null
          };
        },
        methods: {
          close: function close() {
            var toast = getComponentFromVNode(this.toastVNode);
            if (toast) {
              toast.close();
            }
          }
        },
        render: function render() {
          this.toastVNode = h(script, _objectSpread(_objectSpread({}, propsData), {}, {
            // On Vue 3, $destroy is no longer available.
            // A toast has to be unmounted manually.
            onClose: function onClose() {
              if (typeof propsData.onClose === 'function') {
                propsData.onClose();
              }
              // timeout for the animation complete
              // before unmounting
              setTimeout(function () {
                vueInstance.unmount();
              }, 150);
            }
          }), slot != null ? {
            "default": function _default() {
              return slot;
            }
          } : undefined);
          // we are interested in `toastVNode.component` but
          // at this point `toastVNode.component` should be null
          return this.toastVNode;
        }
      });
      if (this.app) {
        copyAppContext(this.app, vueInstance);
      } else {
        // adds $buefy global property
        // so that $buefy.globalNoticeInterval is available on the new Vue app
        vueInstance.config.globalProperties.$buefy = {};
      }
      return vueInstance.mount(container);
    }
  }]);
  return ToastProgrammatic;
}();
var Plugin = {
  install: function install(Vue) {
    registerComponentProgrammatic(Vue, 'toast', new ToastProgrammatic(Vue));
  }
};

export { script as BToast, ToastProgrammatic, Plugin as default };
